export type MeterKind = "hours" | "miles" | "none";

/** Water trucks use miles, trailers and containers have no meter, other types stay on hours. */
export function meterKindForNames(...names: Array<string | null | undefined>): MeterKind {
  for (const raw of names) {
    const name = (raw || "").trim();
    if (!name) {
      continue;
    }

    if (/\btrailers?\b/i.test(name) || /(^|\s)(storage )?containers?$/i.test(name)) {
      return "none";
    }

    if (/\bwater trucks?\b/i.test(name)) {
      return "miles";
    }
  }

  return "hours";
}

export function meterKindLabel(kind: MeterKind): "Hours" | "Miles" | "None" {
  if (kind === "miles") {
    return "Miles";
  }

  if (kind === "none") {
    return "None";
  }

  return "Hours";
}

export function standardMeterUnit(kind: MeterKind): { name: string; primaryAbbreviation: string } {
  if (kind === "miles") {
    return { name: "Miles", primaryAbbreviation: "mls" };
  }

  if (kind === "none") {
    return { name: "None", primaryAbbreviation: "none" };
  }

  return { name: "Hours", primaryAbbreviation: "hrs" };
}

export function metricMeterUnit(kind: MeterKind): { name: string; primaryAbbreviation: string } {
  if (kind === "miles") {
    return { name: "Kilometers", primaryAbbreviation: "km" };
  }

  return standardMeterUnit(kind);
}
